import { Typography, useTheme } from "@mui/material";
import { Link as RouterLink } from "react-router";

export default function Wordmark({ size = "h2", to = null, state = null, sx: sxProp = {} }) {
    const theme = useTheme();
    const wm = theme.custom?.wordmark || {};

    const baseSx = {
        fontFamily: wm.fontFamily,
        letterSpacing: wm.letterSpacing,
        color: theme.custom?.appBar?.fg,
        textShadow: wm.textShadow || "none",
        textDecoration: "none",
        lineHeight: 1,
        fontWeight: wm.fontWeight,
        textTransform: wm.textTransform,
        ...sxProp,
    };

    const text = wm.text || "BETONIJERRY";

    if (to) {
        return (
            <Typography variant={size} component={RouterLink} to={to} state={state} sx={baseSx}>
                {text}
            </Typography>
        );
    }
    return (
        <Typography variant={size} sx={baseSx}>
            {text}
        </Typography>
    );
}
